import * as React from 'react';
import { getActiveVariant } from '../helpers.js';
import { ProductDetailSpecification } from './ProductDetailSpecification.js';
import { useProductDetailContext } from '../ProductDetail/Context/ProductDetailContext.js';

const ProductDetailSpecificationContainer = ({ fallbackConfiguration  })=>{
    const { product , activeSku , specificationConfiguration  } = useProductDetailContext();
    const activeVariant = getActiveVariant(product, activeSku);
    return /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration || fallbackConfiguration,
        variant: activeVariant
    });
};

export { ProductDetailSpecificationContainer };
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
